// fakeData.js
// Utility module for generating random dentists, clinics, and patients

// --- Dentist Names (100) ---
export const dentists = [
    "Dr. Emily Hartwell",
    "Dr. Marcus P. Keller",
    "Dr. Sophia Navarro",
    "Dr. Jonathan Blake",
    "Dr. Rachel Kimura",
    "Dr. David O’Connell",
    "Dr. Isabella Fontana",
    "Dr. Ethan Caldwell",
    "Dr. Priya Sharma",
    "Dr. Benjamin Adler",
    "Dr. Hannah Meijer",
    "Dr. Lucas Andrade",
    "Dr. Charlotte Dufresne",
    "Dr. Noah S. Langston",
    "Dr. Olivia Bennett",
    "Dr. Vincent Moretti",
    "Dr. Laura J. Hwang",
    "Dr. Mateo Ruiz",
    "Dr. Caroline Fischer",
    "Dr. Samuel Greenberg",
    "Dr. Claire Dupont",
    "Dr. Aaron Goldstein",
    "Dr. Naomi Park",
    "Dr. Julian Rosenthal",
    "Dr. Kimberly Vargas",
    "Dr. Elias Becker",
    "Dr. Gabrielle Monroe",
    "Dr. Thomas Lindström",
    "Dr. Fatima Khalil",
    "Dr. Anthony Russo",
    "Dr. Lillian Chen",
    "Dr. Victor Petrov",
    "Dr. Aisha Hussein",
    "Dr. Michael Laurent",
    "Dr. Beatrice Saunders",
    "Dr. Oliver Hunt",
    "Dr. Stella Marquez",
    "Dr. Robert B. Sterling",
    "Dr. Daniela Hoffmann",
    "Dr. Christopher Yates",
    "Dr. Marina Popescu",
    "Dr. Patrick Walsh",
    "Dr. Zoe Al-Mansouri",
    "Dr. Dominic Fraser",
    "Dr. Jennifer Lee",
    "Dr. Paulo Santiago",
    "Dr. Sarah Whitaker",
    "Dr. Ahmed Rashid",
    "Dr. Georgia MacLeod",
    "Dr. Nathaniel Brooks",
    "Dr. Vera Kuznetsova",
    "Dr. Liam Harrington",
    "Dr. Ingrid Dahl",
    "Dr. Brian Cho",
    "Dr. Francesca Romano",
    "Dr. Steven McAllister",
    "Dr. Noura Al-Farooq",
    "Dr. Peter Klein",
    "Dr. Helena Varga",
    "Dr. Charles O’Donnell",
    "Dr. Yasmin Jafari",
    "Dr. Hugo Richter",
    "Dr. Maya Delgado",
    "Dr. Glenn Patterson",
    "Dr. Anna Volkova",
    "Dr. Simon Andersson",
    "Dr. Chloe Ferguson",
    "Dr. Haruto Tanaka",
    "Dr. Camila Duarte",
    "Dr. George Wellington",
    "Dr. Serena Lombardi",
    "Dr. Omar Hassan",
    "Dr. Elise Tremblay",
    "Dr. William Carrington",
    "Dr. Akira Sato",
    "Dr. Fiona Gallagher",
    "Dr. Rami Mansour",
    "Dr. Diana Kovács",
    "Dr. Alexander Boone",
    "Dr. Ivana Stojanovic",
    "Dr. Henry Wallace",
    "Dr. Nadine Choi",
    "Dr. Rafael Medina",
    "Dr. Emily Johansson",
    "Dr. Trevor Mitchell",
    "Dr. Yasuko Arai",
    "Dr. Claudia Schneider",
    "Dr. Victor Novak",
    "Dr. Louise Carter",
    "Dr. Daniel Morales",
    "Dr. Irene Antonelli",
    "Dr. Mustafa Karim",
    "Dr. Claire Boucher",
    "Dr. Patrick Sullivan",
    "Dr. Jing Wu",
    "Dr. Marc Dupuis",
    "Dr. Sophie Lindberg",
    "Dr. Isaiah Freeman",
    "Dr. Natalia Petrova",
    "Dr. Christopher Grant"
  ];
  
  // --- Clinic Names (100) ---
  export const clinics = [
    "BrightPath Orthodontics",
    "Harmony Dental Studio",
    "ClearLine Smiles",
    "Crestview Orthodontics",
    "Radiant Smile Center",
    "TrueNorth Braces Clinic",
    "SmileWorks Orthodontics",
    "Align & Shine Dental",
    "Blue Horizon Orthodontics",
    "The Smile Loft",
    "Aurora Orthodontic Care",
    "Precision Dental Alignment",
    "ClearChoice Orthodontics",
    "PureSmile Orthodontic Center",
    "Horizon Dental Group",
    "Renew Orthodontics",
    "Summit Smile Studio",
    "Infinity Braces Clinic",
    "Elite Orthodontic Partners",
    "Harmony Smiles Dentistry",
    "Everbright Orthodontics",
    "Smile Dynamics Clinic",
    "ClearPath Orthodontic Group",
    "Bright Horizon Dental",
    "The Alignment Studio",
    "Spark Orthodontics",
    "Riverbend Dental & Orthodontics",
    "Stellar Smile Orthodontics",
    "White Oak Braces Center",
    "Apex Orthodontic Specialists",
    "TrueAlign Orthodontics",
    "Golden Gate Orthodontics",
    "Smile Arc Dentistry",
    "Crestline Orthodontic Studio",
    "BrightView Dental",
    "ClearWave Orthodontics",
    "Smile Haven Orthodontic Center",
    "Elevate Dental & Orthodontics",
    "AlignRight Orthodontics",
    "Diamond Orthodontic Care",
    "Smile Harmony Orthodontics",
    "Clear Horizon Dental Group",
    "Serenity Orthodontic Studio",
    "Smile Journey Orthodontics",
    "PureAlign Dental Clinic",
    "Bright Future Orthodontics",
    "Urban Smiles Orthodontics",
    "SmileLink Orthodontic Care",
    "Horizon Align Dentistry",
    "Northern Lights Orthodontics",
    "ClearForm Braces Studio",
    "Sunshine Orthodontic Center",
    "SmileWell Dental & Ortho",
    "Precision Smile Orthodontics",
    "TrueSmile Orthodontics",
    "NewLeaf Dental & Orthodontics",
    "Smile Spectrum Clinic",
    "ClearStep Orthodontics",
    "The Smile Project",
    "Unity Orthodontic Specialists",
    "SmileCore Orthodontics",
    "Brilliance Dental Studio",
    "SmileWise Orthodontic Center",
    "BlueSky Orthodontics",
    "Renew Dental Alignment",
    "SmileTree Orthodontics",
    "Align Plus Orthodontics",
    "EverCare Braces Center",
    "SmileWave Orthodontics",
    "Crestline Dental Group",
    "Smile Bloom Orthodontics",
    "The Brace Place",
    "Infinity Smile Studio",
    "Horizon Dental Partners",
    "AlignCare Orthodontics",
    "BrightStone Dental",
    "SmileCraft Orthodontics",
    "Pure Horizon Orthodontics",
    "EverAlign Dental Clinic",
    "SmileBridge Orthodontics",
    "TruePath Dental Group",
    "SmileNest Orthodontics",
    "SilverLine Orthodontics",
    "SmileBright Dental Partners",
    "ClearWay Orthodontics",
    "BrightBeam Orthodontics",
    "Summit Dental & Braces",
    "SmileForward Orthodontics",
    "Crystal Smile Center",
    "AlignVision Orthodontics",
    "SmileBloom Dental",
    "NorthStar Orthodontics",
    "Clear Arc Dental",
    "SmileMakers Orthodontics",
    "The Ortho Studio",
    "Smile Horizon Dental",
    "Bright Align Orthodontics",
    "Smile Valley Clinic",
    "Apex Dental & Orthodontics",
    "TrueSmile Partners"
  ];
  
  // --- Patient Names (100) ---
  export const patients = [
    "Ava Thompson",
    "Liam Johnson",
    "Sophia Martinez",
    "Noah Brown",
    "Isabella Davis",
    "Mason Wilson",
    "Mia Anderson",
    "Ethan Taylor",
    "Amelia Thomas",
    "Lucas Moore",
    "Charlotte Jackson",
    "Oliver White",
    "Harper Harris",
    "Elijah Martin",
    "Evelyn Thompson",
    "James Garcia",
    "Abigail Martinez",
    "Benjamin Robinson",
    "Ella Clark",
    "Alexander Rodriguez",
    "Scarlett Lewis",
    "Henry Lee",
    "Grace Walker",
    "Jack Hall",
    "Aria Allen",
    "Daniel Young",
    "Chloe King",
    "Matthew Wright",
    "Lily Scott",
    "Samuel Green",
    "Zoe Adams",
    "Sebastian Baker",
    "Nora Nelson",
    "Joseph Carter",
    "Hannah Mitchell",
    "Levi Perez",
    "Layla Roberts",
    "David Turner",
    "Penelope Phillips",
    "Wyatt Campbell",
    "Victoria Parker",
    "John Evans",
    "Riley Edwards",
    "Owen Collins",
    "Aurora Stewart",
    "Luke Sanchez",
    "Lillian Morris",
    "Gabriel Rogers",
    "Ellie Reed",
    "Isaac Cook",
    "Hazel Morgan",
    "Jayden Bell",
    "Violet Murphy",
    "Logan Bailey",
    "Stella Rivera",
    "Carter Cooper",
    "Paisley Richardson",
    "Julian Cox",
    "Savannah Howard",
    "Grayson Ward",
    "Addison Brooks",
    "Leo Gray",
    "Camila James",
    "Dylan Watson",
    "Sofia Bryant",
    "Miles Wood",
    "Madison Diaz",
    "Nathan Kelly",
    "Leah Sanders",
    "Caleb Price",
    "Brooklyn Bennett",
    "Eli Wood",
    "Luna Barnes",
    "Hunter Ross",
    "Avery Henderson",
    "Aaron Coleman",
    "Mila Jenkins",
    "Christian Perry",
    "Elliana Powell",
    "Adrian Long",
    "Lucy Patterson",
    "Jonathan Hughes",
    "Skylar Flores",
    "Thomas Washington",
    "Aubrey Butler",
    "Charles Simmons",
    "Naomi Foster",
    "Christopher Gonzales",
    "Elena Bryant",
    "Nicholas Alexander",
    "Claire Griffin",
    "Dominic Hayes",
    "Bella Myers",
    "Isaiah Ford",
    "Anna Hamilton",
    "Andrew Graham",
    "Caroline Sullivan",
    "Joshua Wallace",
    "Genesis West"
  ];
  
  // --- Utility: random picker ---
  function randomItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
  
  // --- Public API ---
  export const getRandomDentist = () => randomItem(dentists);
  export const getRandomClinic = () => randomItem(clinics);
  export const getRandomPatient = () => randomItem(patients);
  